import { createFileRoute } from '@tanstack/react-router';
import { GenericPageHeader } from '@/components/layout/page-header';
import { Button } from '@/components/ui/button';
import { BookingIntegrations, type TrackingSaveState } from '@/pages/bookings/BookingIntegrations';
import { Save } from 'lucide-react';
import { useCallback, useState } from 'react';
import { useLingui } from '@lingui/react/macro';
import { useSetTitle } from '@/stores/title-context';

function TrackingPage() {
	const { t } = useLingui();
	useSetTitle(t`Tracking`);
	const [saveState, setSaveState] = useState<TrackingSaveState | null>(null);

	const handleSaveStateChange = useCallback((state: TrackingSaveState) => {
		setSaveState(state);
	}, []);

	return (
		<div className="flex flex-col h-full">
			<GenericPageHeader
				title={t`Tracking`}
				actions={
					saveState && (
						<Button
							size="sm"
							data-testid="tracking-save"
							onClick={saveState.onSave}
							disabled={!saveState.isDirty || saveState.isPending}
						>
							<Save className="size-4" />
							{saveState.isPending ? t`Saving...` : t`Save changes`}
						</Button>
					)
				}
			/>
			<div className="flex-1 overflow-y-auto">
				<div className="p-4">
					<BookingIntegrations onSaveStateChange={handleSaveStateChange} />
				</div>
			</div>
		</div>
	);
}

export const Route = createFileRoute('/_authenticated/_app/bookings/tracking')({
	component: TrackingPage,
});
